/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AgentWalletInitiatePaymentRequest} from '@cash-web/protos/squareup/cash/agentcore/api/v1beta1/agent_wallet_initiate_payment_messages.pb'
import {AgentWalletInitiatePaymentResponse} from '@cash-web/protos/squareup/cash/agentcore/api/v1beta1/agent_wallet_initiate_payment_messages.pb'


export const agentCoreAgentWalletInitiatePayment = (request: AgentWalletInitiatePaymentRequest, options?: CashRequestOptions) => post<AgentWalletInitiatePaymentRequest, AgentWalletInitiatePaymentResponse>("/cash-app/agent-core/agent-wallet-initiate-payment", request, {...options, rejectOnError: true })